import React from 'react';
import {useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import styles from "../ApplyForOrder/ApplyForOrder.module.scss";
import AddressDetailsOrder from "../../components/AddressDetailsOrder/AddressDetailsOrder";
import PackageDetailsOrder from "../../components/PackageDetailsOrder/PackageDetailsOrder";
import AdditionalInfoOrder from "../../components/AdditionalInfoOrder/AdditionalInfoOrder";
import AddedPhotosCustomerOrder from "../../components/AddedPhotosCustomerOrder/AddedPhotosCustomerOrder";
import money from "../../constants/images/bag-of-money.svg";

const AppliedApplicationDetailsPage = () => {
  const {pathname} = useLocation();

  const array = pathname.split('/');
  let id; // getting id from url
  if ((typeof +array[array.length - 1] === "number") && (+array[array.length - 1] !== 0)) {
    id = +array[array.length - 1];
  } else {
    id = +array[array.length - 2];
  }

  const {cleanerApplicationsByCurrentCleaner} = useSelector(state => state.cleanerApplications);
  const cleanerApplication = cleanerApplicationsByCurrentCleaner.find((item, index) => item.id === id);

  const {request, application_price, application_message} = cleanerApplication;
  const {
    request_datetime, address, request_price, get_total_price, service_package,
    services,
    reg_window_count,
    pano_window_count,
    wc_count,
    room_count,
    cleaning_type,
    photos,
    present_at_home,
    comment,
    present_at_home_desc,
    get_minimal_recommended_price,
  } = request;

  return (
    <div className={styles.applyForOrder_wrapper}>
      <div className={styles.applyForOrder}>
        <h1 className={styles.applyForOrder_title}>Подана заявка</h1>

        <div className={styles.applyForOrder_orderDetails}>
          <AddressDetailsOrder
            address={address}
            date={new Date(request_datetime).toLocaleDateString()}
            time={new Date(request_datetime).toLocaleTimeString()}
            price={+request_price || get_total_price}
          />
          <PackageDetailsOrder
            style={{'padding': '24px 24px 16px 24px', 'borderBottom': '1px solid #D9DBDD'}}
            showTitle={true}
            selectedPackage={service_package?.name}
            services={services}
            countOrdinaryWindows={reg_window_count}
            countPanoramicWindows={pano_window_count}
            countBathrooms={wc_count}
            countRooms={room_count}
            typeCleaning={cleaning_type}
          />
          <AdditionalInfoOrder
            isBorderBottom={photos?.length > 0}
            present_at_home={present_at_home}
            additionalComments={comment}
            present_at_home_desc={present_at_home_desc}
          />
          {photos?.length > 0 && <AddedPhotosCustomerOrder photos={photos}/>}
        </div>
        <form action={"#"} className={styles.applyForOrder_offeredPrice}>
          <div className={styles.applyForOrder_offeredPrice_container}>
            <h3 className={styles.applyForOrder_offeredPrice_container_title}>Ваша ціна</h3>
            <div className={styles.applyForOrder_offeredPrice_container_block}>
              <img src={money} alt="bag of money"/>
              <div>
                <p>Введена вартість (грн)</p>
                <div className={styles.error}>
                  <input
                    className={styles.input}
                    type="number"
                    defaultValue={application_price}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.applyForOrder_offeredPrice_block}>
            <div className={styles.applyForOrder_offeredPrice_block_description}>
              <p className={styles.applyForOrder_offeredPrice_block_description_title}>Загальна вартість
                прибирання</p>
              <p className={styles.applyForOrder_offeredPrice_block_description_subtitle}>Це вартість, яку
                ви пропонуєте за послуги</p>
            </div>

            <p
              className={styles.applyForOrder_offeredPrice_block_price}>₴ {application_price || (+request_price || get_total_price)}</p>
          </div>

          <div className={styles.applyForOrder_offeredPrice_block}>
            <div className={styles.applyForOrder_offeredPrice_block_description}>
              <p className={styles.applyForOrder_offeredPrice_block_description_title}>20% комісія
                платформи</p>
            </div>

            <p
              className={styles.applyForOrder_offeredPrice_block_price}>-₴ {+(application_price * 0.2).toFixed(2) || (+(request_price * 0.2).toFixed(2) || (get_total_price - get_minimal_recommended_price).toFixed(2))}
            </p>
          </div>

          <div className={styles.applyForOrder_offeredPrice_block}>
            <div className={styles.applyForOrder_offeredPrice_block_description}>
              <p className={styles.applyForOrder_offeredPrice_block_description_title}>Ви отримаєте</p>
              <p className={styles.applyForOrder_offeredPrice_block_description_subtitle}>Фінальний
                платіж,
                який ви отримаєте після оплати комісійного збору</p>
            </div>

            <p
              className={styles.applyForOrder_offeredPrice_block_price}>₴ {(+application_price * 0.8).toFixed(2) || (+(+request_price * 0.8).toFixed(2) || get_minimal_recommended_price)}</p>
          </div>

          <div className={styles.error}>
            <label
              className={styles.applyForOrder_offeredPrice_message}
              htmlFor={'message'}
            >Повідомлення замовнику
              <textarea
                id="message"
                rows="4"
                className={styles.applyForOrder_offeredPrice_message_input}
                placeholder={'Повідомлення'}
                defaultValue={application_message}
                disabled={true}
              ></textarea>
            </label>
          </div>

        </form>
      </div>
    </div>
  );
};

export default AppliedApplicationDetailsPage;
